import React, { forwardRef, useEffect } from 'react';
import './input.scss';
export var Input = forwardRef(function (_a, ref) {
    var id = _a.id, _b = _a.type, type = _b === void 0 ? 'text' : _b, placeHolder = _a.placeHolder, onChange = _a.onChange, onKeyUp = _a.onKeyUp, setValue = _a.setValue, disabled = _a.disabled, required = _a.required, error = _a.error, childClasses = _a.childClasses, value = _a.value, name = _a.name;
    var inputClasses = 'c-input';
    useEffect(function () {
        if (value) {
            setValue(id, value);
        }
    }, [value]);
    if (disabled) {
        inputClasses += ' isDisabled';
    }
    if (error) {
        inputClasses += ' isInvalid';
    }
    if (required) {
        inputClasses += ' isRequired';
    }
    if (value) {
        inputClasses += ' hasValue';
    }
    if (childClasses) {
        inputClasses += " ".concat(childClasses);
    }
    return (React.createElement("input", { type: type, id: id, name: name !== null && name !== void 0 ? name : id, placeholder: placeHolder, className: inputClasses, ref: ref, "aria-invalid": error ? 'true' : 'false', required: required, disabled: disabled, onKeyUp: onKeyUp, onChange: onChange }));
});
Input.displayName = 'Input';
